// Initialize autosave when page loads
document.addEventListener('DOMContentLoaded', function() {
  console.log('Ready!')
});
